import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/risk360/factor-rules/')({
  validateSearch: zodValidator(withDefaults(schema.FACTOR_RULES, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.FACTOR_RULES }) || !!context.userPermissions.isInternalRole;
    context.validatePermissions({ isAllowed, preload });
  },
});
